import React, { useState, useRef, useEffect } from "react";

type DropdownMenuProps = {
  options: any;
  icon: React.ReactNode;
  item?: any; // Optional
};

const DropdownMenu = ({ options, icon, item }: DropdownMenuProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const toggleDropdown = () => setIsOpen((prev) => !prev);

  const handleClickOutside = (event: MouseEvent) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target as Node)
    ) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative inline-block" ref={dropdownRef}>
      {/* Icon Trigger */}
      <div onClick={toggleDropdown} className="cursor-pointer">
        {icon}
      </div>

      {/* Dropdown Menu */}
      {isOpen && (
        <div className="absolute right-6  top-[-25px] w-auto bg-white border rounded-md shadow-lg z-50 min-w-[200px]">
          <ul className="py-2 text-sm text-gray-700">
            {options.map((option: any) => (
              <li key={option}>
                <button
                  onClick={() => {
                    setIsOpen(false);
                    // Call the onClick function with item[returnOnClick] only if both are provided
                    if (option?.returnBy) {
                      option.onClick(item[option?.returnBy]);
                    } else if (option?.returnAll) {
                      option.onClick(item);
                    } else {
                      option.onClick(); // Pass no argument if item or returnOnClick is undefined
                    }
                  }}
                  className="w-full text-left px-4 py-2 hover:bg-gray-100 flex"
                >
                  {option.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default DropdownMenu;
